import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { uniq } from 'lodash';
import { ReportConfigurationModel } from 'store/models/reportConfiguration';

export type State = {
	items: ReportConfigurationModel[],
	selectedItems: number[],
	deleteLoading: boolean,
	deleteError: boolean
};

export const INITIAL_STATE: State = {
	items: [],
	selectedItems: [],
	deleteLoading: false,
	deleteError: false
};

const slice = createSlice({
	name: 'reportManager',
	initialState: INITIAL_STATE,
	reducers: {
		setReportConfigurations: (state, action: PayloadAction<ReportConfigurationModel[]>) => {
			state.items = [...action.payload];
		},
		setSelectedItems: (state, action: PayloadAction<number[]>) => {
			state.selectedItems = action.payload;
		},
		addItemToSelection: (state, action: PayloadAction<number>) => {
			state.selectedItems = uniq([...state.selectedItems, action.payload]);
		},
		addItemsToSelection: (state, action: PayloadAction<number[]>) => {
			state.selectedItems = uniq([...state.selectedItems, ...action.payload]);
		},
		removeItemFromSelection: (state, action: PayloadAction<number>) => {
			state.selectedItems = state.selectedItems.filter(item => item !== action.payload);
		},
		removeItemsFromSelection: (state, action: PayloadAction<number[]>) => {
			state.selectedItems = state.selectedItems.filter(item => !action.payload.includes(item));
		},
		setDeleteLoading: (state, action: PayloadAction<boolean>) => {
			state.deleteLoading = action.payload;
		},
		setDeleteError: (state, action: PayloadAction<boolean>) => {
			state.deleteError = action.payload;
		}
	}
});

export const {
	setReportConfigurations,
	addItemToSelection,
	addItemsToSelection,
	removeItemFromSelection, 
	removeItemsFromSelection,
	setSelectedItems,
	setDeleteLoading,
	setDeleteError
} = slice.actions;

export const reducers = slice.reducer;
